import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  notifications: true,
  darkMode: false,
  fontSize: "medium",
};

const UserSettingsSlice = createSlice({
  name: "userSettings",
  initialState,
  reducers: {
    toggleNotifications: (state) => {
      state.notifications = !state.notifications;
    },
    toggleDarkMode: (state) => {
      state.darkMode = !state.darkMode;
    },
    setFontSize: (state, action) => {
      state.fontSize = action.payload;
    },
  },
});

export const { toggleNotifications, toggleDarkMode, setFontSize } =
  UserSettingsSlice.actions;

export default UserSettingsSlice.reducer;
